(function(){
  const svgBase   = document.getElementById('ikSVG');
  const svgMirror = document.getElementById('ikSVGMirror');

  const baseGroups = {
    anchor:  svgBase.querySelector('#anchorGroup'),
    bone0:   svgBase.querySelector('#bone0Group'),
    roller0: svgBase.querySelector('#roller0Group'),
    blue0:   svgBase.querySelector('#blue0Group'),
    bone1:   svgBase.querySelector('#bone1Group'),
    roller1: svgBase.querySelector('#roller1Group'),
    blue1:   svgBase.querySelector('#blue1Group'),
    wrist:   svgBase.querySelector('#wristGroup'),
  };
  const mirrorGroups = {
    anchor:  svgMirror.querySelector('#anchorGroup'),
    bone0:   svgMirror.querySelector('#bone0Group'),
    roller0: svgMirror.querySelector('#roller0Group'),
    blue0:   svgMirror.querySelector('#blue0Group'),
    bone1:   svgMirror.querySelector('#bone1Group'),
    roller1: svgMirror.querySelector('#roller1Group'),
    blue1:   svgMirror.querySelector('#blue1Group'),
    wrist:   svgMirror.querySelector('#wristGroup'),
  };

  const L        = 150;
  const smoothK  = 0.05;
  const durJ     = 1500;
  const durW     = 500;
  const totalDur = durJ + durW;
  const restSa   = -Math.PI/2;
  const restEa   = Math.PI;
  const coeff    = { aS:1, mS:0.01, aE:1, mE:0.2 };
  const root     = { x:0, y:0 };

  let trg      = { x:0, y:0 };
  let sm       = { x:0, y:0 };
  let sa       = 0;
  let ea       = 0;
  let wrPhase  = 0;
  let inRest   = true;
  let outRest  = false;
  let start    = performance.now() - totalDur;

  let prevSm   = { x:0, y:0 };
  let prevJ1   = null;
  let prevSa   = 0;
  let prevEl   = 0;
  let rollSh   = 0;
  let rollEl   = 0;

  // mirror control
  let mirrorEnabled   = true;
  let mirrorStartTime = 0;

  function clamp(v,m,M){ return v<m?m:v>M?M:v; }
  function ease(t){ return t<0?0:t>1?1:3*t*t-2*t*t*t; }
  function toDeg(r){ return (r*180/Math.PI).toFixed(2); }

  function angles(r,t){
    const dx = t.x - r.x, dy = t.y - r.y;
    const d  = clamp(Math.hypot(dx,dy), 1e-6, 2*L);
    const baseA = Math.atan2(dy,dx);
    const a     = Math.acos(clamp(d/(2*L), -1,1));
    const b     = Math.acos(clamp((2*L*L - d*d)/(2*L*L), -1,1));
    return { sa: baseA + a, ea: -(Math.PI - b) };
  }

  function joints(r,a){
    const j1 = {
      x: r.x + Math.cos(a.sa)*L,
      y: r.y + Math.sin(a.sa)*L
    };
    return {
      j1,
      j2: {
        x: j1.x + Math.cos(a.sa + a.ea)*L,
        y: j1.y + Math.sin(a.sa + a.ea)*L
      }
    };
  }

  window.addEventListener('mousemove', e=>{
    const rect = svgBase.getBoundingClientRect();
    const vb   = svgBase.viewBox.baseVal;
    trg.x = vb.x + (e.clientX - rect.left) * vb.width  / rect.width;
    trg.y = vb.y + (e.clientY - rect.top ) * vb.height / rect.height;
  });

  window.addEventListener('keydown', e=>{
    const k = e.key.toLowerCase();
    if (k === 'x' && !inRest) {
      inRest = true; outRest = false; start = performance.now();
    }
    if (k === 'z' && inRest) {
      inRest = false; outRest = true; start = performance.now();
    }
    if (k === 'q' || k === 'e') {
      mirrorEnabled = !mirrorEnabled;
      if (!mirrorEnabled) {
        mirrorStartTime = performance.now();
      }
    }
  });

  function apply(groups, a, js, phase, sh, el){
    groups.anchor .setAttribute('transform',
      `translate(${root.x},${root.y}) scale(.07) rotate(180)`);
    groups.bone0  .setAttribute('transform',
      `translate(${root.x},${root.y}) rotate(${toDeg(a.sa)}) scale(${(L/943).toFixed(3)})`);
    groups.roller0.setAttribute('transform',
      `translate(${root.x},${root.y}) rotate(${toDeg(sh)}) scale(.035)`);
    groups.blue0  .setAttribute('transform',
      `translate(${root.x},${root.y}) scale(.07)`);
    groups.bone1  .setAttribute('transform',
      `translate(${js.j1.x},${js.j1.y}) rotate(${toDeg(a.sa + a.ea)}) scale(${(L/943).toFixed(3)})`);
    groups.roller1.setAttribute('transform',
      `translate(${js.j1.x},${js.j1.y}) rotate(${toDeg(el)}) scale(.025)`);
    groups.blue1  .setAttribute('transform',
      `translate(${js.j1.x},${js.j1.y}) scale(.05)`);
    groups.wrist  .setAttribute('transform',
      `translate(${js.j2.x},${js.j2.y}) rotate(${toDeg(a.sa + a.ea + phase)}) scale(.4)`);
  }

  function loop(ts){
    sm.x += (trg.x - sm.x) * smoothK;
    sm.y += (trg.y - sm.y) * smoothK;

    const real = angles(root, sm);

    if (inRest || outRest) {
      const t   = ts - start;
      const tj  = clamp(t / durJ, 0,1);
      const te  = clamp((t - durJ) / durW, 0,1);
      const kf  = inRest ? ease(tj) : 1 - ease(tj);
      sa      = real.sa*(1-kf) + restSa*kf;
      ea      = real.ea*(1-kf) + restEa*kf;
      wrPhase = (inRest ? ease(te) : ease(1-te)) * Math.PI;
      if (t >= totalDur) { inRest = !outRest; outRest = false; }
    } else {
      sa      = real.sa;
      ea      = real.ea;
      wrPhase = 0;
    }

    const jsBase = joints(root, { sa, ea });
    const moveSm = Math.hypot(sm.x - prevSm.x, sm.y - prevSm.y);
    const moveEl = prevJ1
      ? Math.hypot(jsBase.j1.x - prevJ1.x, jsBase.j1.y - prevJ1.y)
      : 0;
    const dSa = sa - prevSa;
    const dEl = (sa + ea) - prevEl;
    rollSh += dSa * coeff.aS + moveSm * coeff.mS;
    rollEl += dEl * coeff.aE + moveEl * coeff.mE;

    apply(baseGroups, { sa, ea }, jsBase, wrPhase, rollSh, rollEl);

    prevSm  = { ...sm };
    prevJ1  = { ...jsBase.j1 };
    prevSa  = sa;
    prevEl  = sa + ea;

    // mirror hand: normal or folding
    if (mirrorEnabled) {
      const saM   = Math.PI - sa;
      const eaM   = -ea;
      const jsMir = joints(root, { sa: saM, ea: eaM });
      apply(mirrorGroups, { sa: saM, ea: eaM }, jsMir, wrPhase, -rollSh, -rollEl);
    } else {
      const t         = ts - mirrorStartTime;
      const tj        = clamp(t / durJ, 0,1);
      const te        = clamp((t - durJ) / durW, 0,1);
      const kf        = ease(tj);
      const saM       = real.sa*(1-kf) + restSa*kf;
      const eaM       = real.ea*(1-kf) + restEa*kf;
      const phaseFold = ease(te) * Math.PI;
      const jsMir     = joints(root, { sa: saM, ea: eaM });
      apply(mirrorGroups, { sa: saM, ea: eaM }, jsMir, phaseFold, -rollSh, -rollEl);
    }

    requestAnimationFrame(loop);
  }

  requestAnimationFrame(loop);
})();
